import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { IGetCanalAtencion } from '../../shared/interfaces/database/evento';

@Injectable({
  providedIn: 'root'
})
export class CanalAtencionService {
  private readonly baseUrl = `${environment.apiUrl}/api/canal-atencion`;

  constructor(private http: HttpClient) { }

  getCanalesAtencions(): Observable<IGetCanalAtencion[]> {
    return this.http.get<IGetCanalAtencion[]>(`${this.baseUrl}`);
  }
}
